import { NavLink } from "react-router-dom";
import styled from "styled-components";
import logo from "../assets/FinalLogo.png";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import LocaleTitle from "./LocaleTitle";
import { useIntl } from "react-intl";

const Header = ({ changeLocale }) => {
  const intl = useIntl();
  const [isHamburgerOpen, setHamburgerOpen] = useState(false);
  const activeStyle = {
    fontWeight: `${intl.locale === "en" ? "700" : "900"}`,
    "& .chTitle": {
      fontWeight: "900",
    },
  };

  return (
    <Wrapper>
      <NavLink to={"/"}>
        <LogoImage src={logo} alt={"history trail logo"} />
      </NavLink>
      <NavWrapper>
        <NavigationLinkContainer>
          <NavLink
            to={"/"}
            style={({ isActive }) => (isActive ? activeStyle : undefined)}
          >
            {({ isActive }) => (
              <LocaleTitle isActive={isActive}>
                <FormattedMessage defaultMessage={"Home"} id="header.home" />
              </LocaleTitle>
            )}
          </NavLink>
          <NavLink
            to={"/directory"}
            style={({ isActive }) => (isActive ? activeStyle : undefined)}
          >
            {({ isActive }) => (
              <LocaleTitle isActive={isActive}>
                <FormattedMessage
                  defaultMessage={"Directory"}
                  id="header.directory"
                />
              </LocaleTitle>
            )}
          </NavLink>
          <NavLink
            to={"/about"}
            style={({ isActive }) => (isActive ? activeStyle : undefined)}
          >
            {({ isActive }) => (
              <LocaleTitle isActive={isActive}>
                <FormattedMessage defaultMessage={"About"} id="header.about" />
              </LocaleTitle>
            )}
          </NavLink>
          <a
            href={"https://forms.gle/9NPYBbUc8ErcP7tn6"}
            target="_blank"
            rel="noreferrer"
          >
            <LocaleTitle isActive={false}>
              <FormattedMessage defaultMessage={"Submit"} id="header.submit" />
            </LocaleTitle>
          </a>
        </NavigationLinkContainer>
        <LanguageSwitcher onClick={changeLocale}>
          <LanguageOption isActive={intl.locale === "en"}>EN</LanguageOption>
          <span>/</span>
          <LanguageOption isActive={intl.locale === "zh"} isChinese>
            中文
          </LanguageOption>
        </LanguageSwitcher>
        <HamburgerMenu onClick={() => setHamburgerOpen(!isHamburgerOpen)}>
          {isHamburgerOpen ? <CloseIcon /> : <MenuIcon />}
        </HamburgerMenu>
      </NavWrapper>
      {isHamburgerOpen && (
        <DropdownMenu>
          <NavLink
            onClick={() => setHamburgerOpen(false)}
            to={"/"}
            style={({ isActive }) => (isActive ? activeStyle : undefined)}
          >
            <LocaleTitle isActive={window.location.pathname === "/"}>
              <FormattedMessage defaultMessage={"Home"} id="header.home" />
            </LocaleTitle>
          </NavLink>
          <NavLink
            onClick={() => setHamburgerOpen(false)}
            to={"/directory"}
            style={({ isActive }) => (isActive ? activeStyle : undefined)}
          >
            <LocaleTitle isActive={window.location.pathname === "/directory"}>
              <FormattedMessage
                defaultMessage={"Directory"}
                id="header.directory"
              />
            </LocaleTitle>
          </NavLink>
          <NavLink
            onClick={() => setHamburgerOpen(false)}
            to={"/about"}
            style={({ isActive }) => (isActive ? activeStyle : undefined)}
          >
            <LocaleTitle isActive={window.location.pathname === "/about"}>
              <FormattedMessage defaultMessage={"About"} id="header.about" />
            </LocaleTitle>
          </NavLink>
          <NavLink
            onClick={() => setHamburgerOpen(false)}
            to={"https://forms.gle/9NPYBbUc8ErcP7tn6"}
            style={({ isActive }) => (isActive ? activeStyle : undefined)}
          >
            <LocaleTitle isActive={false}>
              <FormattedMessage defaultMessage={"Submit"} id="header.submit" />
            </LocaleTitle>
          </NavLink>
        </DropdownMenu>
      )}
    </Wrapper>
  );
};

export default Header;

const DropdownMenu = styled.div`
  position: absolute;
  bottom: -258px;
  left: 0;
  height: 258px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 40px;
  background: inherit;
  z-index: 100;
  font-family: "Rowdies";
  font-weight: 300;
  font-size: 22px;
  line-height: 120%;
  text-transform: uppercase;
  color: #423f67;

  box-shadow: 0 17px 20px 0 rgba(66, 63, 103, 0.25);

  @media (min-width: 800px) {
    display: none;
  }
`;

const HamburgerMenu = styled.button`
  color: #423f67;
  background: none;
  border: none;
  cursor: pointer;
  @media (min-width: 800px) {
    display: none;
  }
`;

const LogoImage = styled.img`
  height: 96px;
`;

const Wrapper = styled.div`
  width: 100%;
  height: 88px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 32px;
  box-sizing: border-box;
  background-color: #fbf6e9;
  position: relative;
  z-index: 101;

  border-bottom: 1px solid #d4d4d4;
  a {
    color: #423f67;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: 300;
    font-size: 16px;
    line-height: 120%;
  }
  h1 {
    font-size: 10px;
  }
  @media (max-width: 800px) {
    padding: 12px 12px 12px 4px;
  }
`;

const NavWrapper = styled.div`
  display: flex;
  gap: 1rem;
`
const NavigationLinkContainer = styled.div`
  display: none;
  gap: 1rem;
  align-items: center;
  text-align: center;
  @media (min-width: 800px) {
    display: flex;
  }
    
`;

const LanguageSwitcher = styled.button`
  font-family: Rowdies;
  font-weight: 300;
  font-size: 16px;
  line-height: 120%;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  color: #423f67;
  padding: 0;
`;

const LanguageOption = styled.span`
  padding: 0px 4px;
  border-radius: 4px;
  background-color: ${(props) => (props.isActive ? "#ffd44a" : "transparent")};
  font-family: ${(props) => (props.isChinese ? "Noto Sans SC" : "Rowdies")};
  font-weight: ${(props) => (props.isChinese ? "700" : "300")};
`;
